// extracted by mini-css-extract-plugin
module.exports = {"cls1":"NavbarNavItem-module--cls1--2CsAw","cls2":"NavbarNavItem-module--cls2--mrNmn NavbarNavItem-module--cls1--2CsAw","active":"NavbarNavItem-module--active--Mo4FM"};